
async function loadButtons (data) {
    console.log('AppClientStore.loadButtons() -> ', data);
    const env = this.env;
    const widgetsList = await env.widgetStore.getWidgets(data.buttons);
    this.notifyClientPage({
        action: 'buttonsLoaded',
        data: {
            widgetsList,
        },
    });
}

export default loadButtons;